import { cx } from '../utils/cx'
import type { AccentVar } from '../AccentContext'

interface WhoFromProps {
  initials: string
  avatarColor?: AccentVar | string
  name: string
  email?: string
  className?: string
}

export function WhoFrom({ initials, avatarColor, name, email, className }: WhoFromProps) {
  return (
    <div className={cx('st-who-from', className)}>
      <span className="avatar" style={avatarColor ? { background: `var(${avatarColor})` } : undefined}>
        {initials}
      </span>
      <div>
        <b>{name}</b>
        <span>{email}</span>
      </div>
    </div>
  )
}
